import React, { Component } from 'react';
import AboutDashboard from '../components/aboutComponents/AboutDashboard';

export default class About extends Component {
  render() {
    return <AboutDashboard />;
  }
}
